import { t } from "@lingui/macro";
import { atom } from "jotai";

import {
  BookingWizardDataAtom,
  CurrentBookingWizardStepAtom,
  CurrentRequestGroupIndexAtom,
} from "../../stores";

export const panelHeaderTitleAtom = atom<string>((get) => {
  const currentStep = get(CurrentBookingWizardStepAtom);
  const bookingWizardData = get(BookingWizardDataAtom);

  if (
    (currentStep === "AddPlayers" || currentStep === "AddPlayersPrivate") &&
    bookingWizardData?.type === "RequestBooking" &&
    (bookingWizardData.requestGroupCount ?? 1) > 1
  ) {
    const requestGroupCount = bookingWizardData.requestGroupCount ?? 1;
    return t`Group ${
      get(CurrentRequestGroupIndexAtom) + 1
    } of ${requestGroupCount}`;
  }

  switch (currentStep) {
    case "BookingDetails":
      return t`Booking Details`;
    case "AddPlayers":
    case "AddPlayersPrivate":
      return t`Playing With Anyone?`;
    case "PreviousBookings":
      return t`New Booking`;
    default:
      return "";
  }
});
